import { render, staticRenderFns } from "./registrationConfirmInstall.vue?vue&type=template&id=06a3095a&scoped=true"
import script from "./registrationConfirmInstall.vue?vue&type=script&lang=js"
export * from "./registrationConfirmInstall.vue?vue&type=script&lang=js"
import style0 from "./registrationConfirmInstall.vue?vue&type=style&index=0&id=06a3095a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a3095a",
  null
  
)

export default component.exports